import { render, staticRenderFns } from "./ModalLogistica.vue?vue&type=template&id=acb438c4&scoped=true"
import script from "./ModalLogistica.vue?vue&type=script&lang=js"
export * from "./ModalLogistica.vue?vue&type=script&lang=js"
import style0 from "./ModalLogistica.vue?vue&type=style&index=0&id=acb438c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb438c4",
  null
  
)

export default component.exports